


























































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  GetAuthSmsRequest,
  PostAuthSmsRequest,
  PutAdminsTempServiceRequest,
  GetAdminsTempServiceExistsRequest
} from 'supporter';
import {isMobileNoValidated, resultNcpPolicyPasswordEnum, validateNcpPolicyPassword} from '@/utils/validateUtils';
import {toI18n} from '@/utils/commonUtils';

enum INPUT_ID_STATE {
  NONE = 'NONE',
  SHORT = 'SHORT',
  PASS = 'PASS',
  FAIL = 'FAIL'
}
enum INPUT_PASSWORD_STATE {
  NONE = 'NONE',
  SHORT = 'SHORT',
  COMPLEXITY_2 = 'COMPLEXITY_2',
  COMPLEXITY_3 = 'COMPLEXITY_3',
  WRONG_SPECIAL = 'WRONG_SPECIAL',
  PASS = 'PASS'
}
enum INPUT_PASSWORD_CONFIRM_STATE {
  NONE = 'NONE',
  PASS = 'PASS',
  FAIL = 'FAIL'
}
enum AUTH_BY_SMS {
  NONE = 'NONE',
  NOT_VALID = 'NOT_VALID',
  SENDING = 'SENDING',
  COMPLETE = 'COMPLETE',
  FAIL = 'FAIL'
}
interface AuthSmsInfo {
  status: AUTH_BY_SMS;
  certKey: string;
}

@Component
export default class ServiceMasterRegisterForm extends Vue {
  @Prop() private masterData: any;

  private adminName: string = '';
  private request: PutAdminsTempServiceRequest = {
    data: {
      password: '',
      passwordConfirm: '',
      adminId: '',
      departmentNo: 0,
      smsAuthKey: '',
      tempCode: '',
      mobileNo: '',
      jobPositionName: '',
      phoneNo: '',
      externalAccessEnabled: false,
      jobDutyNo: 0
    }
  };
  private inputIdState: INPUT_ID_STATE = INPUT_ID_STATE.NONE;

  private inputPasswordState: INPUT_PASSWORD_STATE = INPUT_PASSWORD_STATE.NONE;
  private bShowInputPasswordGuide: boolean = false;
  private inputPasswordConfirmState: INPUT_PASSWORD_CONFIRM_STATE = INPUT_PASSWORD_CONFIRM_STATE.NONE;

  private authSmsInfo: AuthSmsInfo = {
    status: AUTH_BY_SMS.NONE,
    certKey: ''
  };

  /**
   * data init from parent view data
   */
  @Watch('masterData')
  onMasterDataChange(): void {
    this.adminName = this.masterData.adminName || '';

    this.request.data.adminId = this.masterData.adminId || '';
    this.request.data.departmentNo = this.masterData.departmentNo || 0;
    this.request.data.mobileNo = this.masterData.contactInfo.mobileNo || '';
    this.request.data.jobPositionName = this.masterData.jobPositionName || '';
    this.request.data.phoneNo = this.masterData.contactInfo.phoneNo || '';
    this.request.data.externalAccessEnabled = this.masterData.externalAccessEnabled || false;
    this.request.data.jobDutyNo = this.masterData.jobDutyNo || 0;
  }

  private initInputIdState(): void {
    this.inputIdState = INPUT_ID_STATE.NONE;
  }

  created() {
    this.request.data.tempCode = this.$route.query.tempCode as string;

    this.$emit('getAdminsTempService');
  }

  /**
   * confirm admin id exist
   */
  private getAdminsTempServiceExists(): Promise<INPUT_ID_STATE> {
    const request: GetAdminsTempServiceExistsRequest = {
      params: {
        adminId: this.request.data.adminId
      }
    };

    return this.$api
      .getAdminsTempServiceExists(request)
      .then(response => {
        if (response && response.status === 200) {
          if (this.request.data.adminId !== response.data.adminId) {
            return INPUT_ID_STATE.NONE;
          }

          return !response.data.exists ? INPUT_ID_STATE.PASS : INPUT_ID_STATE.FAIL;
        }

        return INPUT_ID_STATE.NONE;
      })
      .catch(() => {
        return INPUT_ID_STATE.NONE;
      });
  }

  /**
   * post auth sms (send sms)
   */
  private postAuthSms(): Promise<boolean> {
    const request: PostAuthSmsRequest = {
      data: {
        mobileNo: this.request.data.mobileNo
      }
    };

    return this.$api
      .postAuthSms(request)
      .then((response): boolean => {
        if (response && response.status === 200) {
          return true;
        }
        return false;
      })
      .catch((): boolean => {
        return false;
      });
  }

  /**
   * get auth sms (check auth num)
   */
  private getAuthSms(): Promise<boolean> {
    const request: GetAuthSmsRequest = {
      params: {
        mobileNo: this.request.data.mobileNo,
        key: this.authSmsInfo.certKey
      }
    };

    return this.$api
      .getAuthSms(request)
      .then((response: any): boolean => {
        if (response && response.status === 204) {
          return true;
        }
        return false;
      })
      .catch((): boolean => {
        return false;
      });
  }

  /**
   * put master amin (by tempCode)
   */
  private putAdminsTempService(): Promise<boolean> {
    return this.$api
      .putAdminsTempService(this.request)
      .then(response => {
        if (response && response.status === 204) {
          return true;
        }

        return false;
      })
      .catch(() => {
        return false;
      });
  }

  /**
   * confirm admin id exist
   */
  private confirmAdminIdExist() {
    if (this.request.data.adminId.length < 5) {
      this.inputIdState = INPUT_ID_STATE.SHORT;
      return;
    }

    this.getAdminsTempServiceExists().then((idState: INPUT_ID_STATE) => {
      this.inputIdState = idState;
    });
  }

  /**
   * init password state
   */
  private initPasswordState() {
    this.inputPasswordState = INPUT_PASSWORD_STATE.NONE;
    this.inputPasswordConfirmState = INPUT_PASSWORD_CONFIRM_STATE.NONE;

    this.bShowInputPasswordGuide = true;
  }

  /**
   * check password valid
   */
  private checkPasswordValid(): void {
    this.bShowInputPasswordGuide = false;

    if (this.request.data.password.length < 8) {
      this.inputPasswordState = INPUT_PASSWORD_STATE.SHORT;
    } else {
      const result = validateNcpPolicyPassword(this.request.data.password);
      if (result === resultNcpPolicyPasswordEnum.SUCCESS) {
        this.inputPasswordState = INPUT_PASSWORD_STATE.PASS;
      } else if (result === resultNcpPolicyPasswordEnum.NOT_ALLOW_SPECAIL) {
        this.inputPasswordState = INPUT_PASSWORD_STATE.WRONG_SPECIAL;
      } else if (result === resultNcpPolicyPasswordEnum.AT_LEAST2) {
        this.inputPasswordState = INPUT_PASSWORD_STATE.COMPLEXITY_2;
      } else if (result === resultNcpPolicyPasswordEnum.AT_LEAST3) {
        this.inputPasswordState = INPUT_PASSWORD_STATE.COMPLEXITY_3;
      } else {
        this.inputPasswordState = INPUT_PASSWORD_STATE.NONE;
      }
    }

    if (this.request.data.passwordConfirm.length > 0) {
      this.checkPasswordConfirm();
    }
  }

  /**
   * check password confirm valid
   */
  private checkPasswordConfirm(): void {
    const password = this.request.data.password;
    const passwordConfirm = this.request.data.passwordConfirm;

    if (password === '' && passwordConfirm === '') {
      this.inputPasswordConfirmState = INPUT_PASSWORD_CONFIRM_STATE.NONE;
    } else {
      if (password === passwordConfirm) {
        this.inputPasswordConfirmState = INPUT_PASSWORD_CONFIRM_STATE.PASS;
      } else {
        this.inputPasswordConfirmState = INPUT_PASSWORD_CONFIRM_STATE.FAIL;
      }
    }
  }

  /**
   * show sms message
   */
  private isShowSmsMessage(messageId: string): boolean {
    switch (messageId) {
      case 'sms_certificated':
        return this.authSmsInfo.status === AUTH_BY_SMS.COMPLETE;
      case 'sms_cert_send':
        return this.authSmsInfo.status === AUTH_BY_SMS.SENDING;
      case 'mobileno_not_valid':
        return this.authSmsInfo.status === AUTH_BY_SMS.NOT_VALID;
    }

    return false;
  }

  /**
   * send auth num to mobile
   */
  private sendAuthNumBySms(): void {
    if (!isMobileNoValidated(this.request.data.mobileNo)) {
      this.authSmsInfo.status = AUTH_BY_SMS.NOT_VALID;
      return;
    }

    this.postAuthSms().then((success: boolean): void => {
      if (success) {
        this.authSmsInfo.certKey = '';
        this.authSmsInfo.status = AUTH_BY_SMS.SENDING;
      }
    });
  }

  /**
   * check auth num
   */
  private checkAuthNum(): void {
    this.getAuthSms().then((success: boolean): void => {
      if (success) {
        this.authSmsInfo.status = AUTH_BY_SMS.COMPLETE;
        this.request.data.smsAuthKey = this.authSmsInfo.certKey;
      } else {
        alert(this.toI18n('COMMON_SERVER_ERROR'));
      }
    });
  }

  /**
   * update external access enable changed
   */
  private externalAccessEnabledChanged(enabled: boolean) {
    this.request.data.externalAccessEnabled = enabled;
  }

  /**
   * check input valid before put master admin
   */
  private isFormPassed(): boolean {
    if (this.inputIdState !== INPUT_ID_STATE.PASS) {
      alert(this.toI18n('MASTER_ALERT_ID_DUPLICATE'));
      return false;
    }

    if (this.inputPasswordState !== INPUT_PASSWORD_STATE.PASS) {
      if (this.inputPasswordState === INPUT_PASSWORD_STATE.WRONG_SPECIAL) {
        alert(this.toI18n('MASTER_PASSWORD_WRONG_SPECIAL'));
      } else if (this.inputPasswordState === INPUT_PASSWORD_STATE.COMPLEXITY_2) {
        alert(this.toI18n('MASTER_PASSWORD_COMPLEXITY_2'));
      } else if (this.inputPasswordState === INPUT_PASSWORD_STATE.COMPLEXITY_3) {
        alert(this.toI18n('MASTER_PASSWORD_COMPLEXITY_3'));
      }
      return false;
    }

    if (this.inputPasswordConfirmState !== INPUT_PASSWORD_CONFIRM_STATE.PASS) {
      alert(this.toI18n('MASTER_ALERT_PASSWORD_CONFIRM'));
      return false;
    }

    if (this.request.data.jobPositionName.trim().length === 0) {
      alert(this.toI18n('MASTER_ALERT_INSERT_JOB_POSITION'));
      return false;
    }

    if (this.request.data.phoneNo.trim().length === 0) {
      alert(this.toI18n('MASTER_ALERT_INSERT_PHONE'));
      return false;
    }

    if (this.request.data.mobileNo.trim().length === 0) {
      alert(this.toI18n('MASTER_ALERT_INSERT_MOBILE'));
      return false;
    } else if (!isMobileNoValidated(this.request.data.mobileNo)) {
      alert(this.toI18n('MASTER_ALERT_MOBILE_VALIDATE'));
      return false;
    }

    if (this.authSmsInfo.status !== AUTH_BY_SMS.COMPLETE) {
      alert(this.toI18n('MASTER_ALERT_SMS_AUTH'));
      return false;
    }

    if (confirm(this.toI18n('MASTER_CONFIRM_REGISTER'))) {
      return true;
    }

    return false;
  }

  private prevStep(): void {
    this.$router.back();
  }
  private nextStep(): void {
    if (!this.isFormPassed()) {
      return;
    }

    this.putAdminsTempService().then((success: boolean) => {
      if (success) {
        this.$router.push('/admin/service/master/registerCompletePage?tempCode=' + this.request.data.tempCode);
      }
    });
  }

  private toI18n(needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
